export enum Models {
  GPT_35_TURBO = 'gpt-3.5-turbo',
  GPT_4 = 'gpt-4'
}
